import React from "react";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import {useTranslation} from "react-i18next";
import {changeForm} from "../searchFlightsSlice";

function DestinationAnywhereInput() {
  const {t} = useTranslation();
  const dispatch = useAppDispatch();
  const anywhereConfig = useAppSelector((state) => state.config.components.Inputs.DestinationIata.anywhere);
  const anywhere = useAppSelector(
    (state) => state.searchFlights.form.destinationAnywhere
  );
  const disabled = useAppSelector((state) => state.searchFlights.form.disabled);

  const destinationAirport = useAppSelector((state) => state.searchFlights.form.destinationAirport);

  const onChange = () => {
    dispatch(changeForm({destinationAnywhere: !anywhere, destinationAirport: null}))
  }

  if (!anywhereConfig ||destinationAirport?.readOnly) {
    return null;
  } else {
    return (
      <div className="field is-horizontal">
        <div className="field-label"></div>
        <div className="field-body">
          <div className="field">
            <div className="control">
              <label className="checkbox" title="Direkte Flugverbindungen finden">
                <input type="checkbox" checked={anywhere} onChange={onChange} disabled={disabled}/>
                {t('CHECKBOX_DESTINATION_ANYWHERE')}
              </label>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default DestinationAnywhereInput;